import { render, staticRenderFns } from "./ReviewScroll.vue?vue&type=template&id=438d2428&scoped=true"
import script from "./ReviewScroll.vue?vue&type=script&lang=js"
export * from "./ReviewScroll.vue?vue&type=script&lang=js"
import style0 from "./ReviewScroll.vue?vue&type=style&index=0&id=438d2428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438d2428",
  null
  
)

export default component.exports